<template>
  <div v-if="showForecastToggle" class="forecast-parent">
    <span class="forecast-label">
      {{ $t('forecast') }}
    </span>
    <RexConfigProvider
      :theme="{
        components: {
          Switch: {
            colorPrimary: FORECAST_PRIMARY_COLOR,
            colorPrimaryHover: FORECAST_PRIMARY_COLOR,
          },
          Tag: {
            colorTextLightSolid: 'rgb(245, 150, 0)',
          },
        },
      }"
    >
      <RexSwitchV3
        :checked="isForcastEnabled"
        @onChange="(e) => $emit('change', e)"
        :inverseValues="false"
        :disabled="disabled"
      >
        <template #checkedChildren>
          <BaseIcon name="starFilled" class="forcast-toggle-icon-checked" />
        </template>
        <template #uncheckedChildren>
          <BaseIcon name="starFilled" class="forcast-toggle-icon-unchecked" />
        </template>
      </RexSwitchV3>
      <RexTagV3 color="rgba(245, 150, 0, 0.4)" class="beta-tag">
        {{ $t('betaSm') }}
      </RexTagV3>
    </RexConfigProvider>
  </div>
</template>
<script>
import { FORECAST_PRIMARY_COLOR } from '@/utils/constants';
import RexTagV3 from '@/rex-components/RexTagV3.vue';
import RexSwitchV3 from '@/rex-components/RexSwitchV3.vue';
import { RexConfigProvider } from '@/rex-components/rex.comp.config';
export default {
  name: 'ForecastToggle',
  components: {
    RexSwitchV3,
    RexConfigProvider,
    RexTagV3,
  },
  created() {
    this.FORECAST_PRIMARY_COLOR = FORECAST_PRIMARY_COLOR;
  },
  props: {
    showForecastToggle: {
      type: Boolean,
      default: false,
    },
    isForcastEnabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.forecast-label {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 1rem;
}
.forecast-parent {
  @include flex-center-justify;
  margin-left: auto;
}
.forcast-toggle-icon-checked {
  @include svg-fill($color-white);
}
.forcast-toggle-icon-unchecked {
  @include svg-fill($color-active-blue);
}
.beta-tag {
  font-size: 0.8rem;
  margin-left: 0.5rem;
  font-weight: 600;
}
</style>
